import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLoaderData, useParams } from "react-router-dom";
import Book1 from "../../assets/images/books/inteligencia_emocional.png";
import { useScreenContext } from "../Layout";

function BookSuggestion() {
  type BookParams = {
    bookId: string;
    offerType: string;
  };
  const { t } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();
  const { bookRecommendations } = screenData;

  const { bookId, offerType } = useParams<BookParams>() as BookParams;
  const nextBook = Number(bookId) + 1;
  const nextPath =
    Number(bookId) < 5
      ? `/${offerType ? offerType + "/" : ""}book-suggestion/${nextBook}`
      : `/${offerType ? offerType + "/" : ""}info`;

  const book = bookRecommendations[Number(bookId) - 1];

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: t("layout.cta_continue"),
      nextPath: nextPath,
      progress: 70,
      votting: true,
    }));
  }, [nextPath]);

  const handleUnlike = () => {
    setScreenData(() => ({
      ...screenData,
      votting: true,
      booksUnliked: [...screenData.booksUnliked, book.id],
    }));
  };

  return (
    <div>
      <h1 className="mx-5 mb-4 mt-5 text-2xl font-bold tracking-tight text-gray-900 dark:text-white md:text-4xl">
        {t("book_suggestion.headline")}
      </h1>

      <div
        style={{
          backgroundImage: `url(${book.coverImage})`,
          backgroundSize: "cover",
        }}
        className="mx-auto h-80 w-60 max-w-sm md:mt-20"
      >
        <div className="flex h-full flex-col bg-gradient-to-t from-black p-5  text-left text-white">
          <b className="mt-auto block text-3xl">{book.title}</b>
          <span className=" mt-automt-3">{book.author}</span>
        </div>
      </div>

      <div>
        <Link to={screenData.nextPath} onClick={handleUnlike}>
          <button
            type="button"
            className="my-6 mr-2 -scale-x-100 transform rounded-md bg-blue-500 px-10 py-1 text-xl font-normal text-white "
          >
            👎
          </button>
        </Link>
        <Link to={screenData.nextPath}>
          <button
            type="button"
            className="my-6 rounded-md bg-blue-500 px-10 py-1 text-xl font-normal text-white  "
          >
            👍
          </button>
        </Link>
      </div>
    </div>
  );
}

export default BookSuggestion;
